import React, { useState } from "react";
import Form, { Field, FormFooter } from "@atlaskit/form";
import ButtonGroup from "@atlaskit/button/button-group";
import Button from "@atlaskit/button/custom-theme-button";
import TextField from "@atlaskit/textfield";
import SectionMessage from "@atlaskit/section-message";
import styled from "styled-components";
import PageHeader from "@atlaskit/page-header";
import useLogin from "./use-login";
import { Link, Redirect, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function NewPasswordForm() {
    const { t } = useTranslation();
    const { setNewPassword, isError, error, isPending } = useLogin();
    const [ submitted, setSubmitted ] = useState(false);
    const query = useQuery();
    const token = query.get("token");

    if (!token) {
        return <Redirect to="/login" />;
    }

    const submit = data => {
        setNewPassword(token, data).then(() => {
            toast.success(t("new_password_form_success"));
            setSubmitted(true);

            setTimeout(() => window.location.href = "/login", 1000);
        }).catch(() => { });
    };

    return <Wrapper>
        <PageHeader>{t("new_password_form_heading")}</PageHeader>
        {!submitted && <Form onSubmit={data => submit(data)}>
            {({ formProps }) => (
                <form {...formProps}>
                    <Field name="email" defaultValue="" label={t("new_password_form_email")} isRequired>
                        {({ fieldProps }) => <TextField {...fieldProps} isInvalid={isError && error?.errors?.email} />}
                    </Field>
                    <Field name="password" defaultValue="" label={t("new_password_form_password")} isRequired>
                        {({ fieldProps }) => <TextField {...fieldProps} type="password" isInvalid={isError && error?.errors?.password} />}
                    </Field>
                    <Field name="password_confirmation" defaultValue="" label={t("new_password_form_password_confirmation")} isRequired>
                        {({ fieldProps }) => <TextField {...fieldProps} type="password" isInvalid={isError && error?.errors?.password} />}
                    </Field>
                    <FormFooter>
                        <ButtonGroup>
                            <Button type="button" appearance="default">
                                <Link to="/login">
                                    {t("new_password_form_signin")}
                                </Link>
                            </Button>
                            <Button type="submit" appearance="primary" isLoading={isPending}>
                                {t("new_password_form_save")}
                            </Button>
                        </ButtonGroup>
                    </FormFooter>
                </form>
            )}
        </Form>}

        <SectionMessageWrapper>
            {isError
                && <SectionMessage title={t("new_password_form_error_heading")} appearance="error">
                    <p>{error?.message}</p>
                    {error?.errors && <ul>
                        {Object.keys(error.errors).map(key => (
                            <li key={key}>{error.errors[key]}</li>
                        ))}
                    </ul>}
                </SectionMessage>}
            {submitted && <SectionMessage title={t("new_password_form_reset_heading")} appearance="success">
                <p>{t("new_password_form_reset_p")}</p>
            </SectionMessage>}
        </SectionMessageWrapper>
    </Wrapper>;
}

export default NewPasswordForm;

const Wrapper = styled.div`
    width: 400px;
`;

const SectionMessageWrapper = styled.div`
    margin-top: 50px;
    font-size: 13px;
`;